// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Tax from '../components/Tax/Tax';
import {actions} from '../duck';
import {actions as ManualOrderActions} from '../../../manual-order/duck';
import {actions as CategoryActions} from '../../../categories/duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    country: state.country.country,
    isFetching: state.taxesConfig.isFetching,
    tax: state.taxesConfig.tax,
    isSaving: state.taxesConfig.isSaving,
    saveSuccess: state.taxesConfig.saveSuccess,
    error: state.coupons.error,
    currency: state.currency.currency,
    productsFilter: state.manualOrder.products,
    paginationProducts: state.manualOrder.pagination,
    categoriesFilter: state.categories.categoriesFilter,
    isFetchingProducts: state.manualOrder.isFetchingProducts,
    isFetchingCategories: state.categories.isFetching,
    paginationCategories: state.categories.paginationFilter,
  }),
  (dispatch: Dispatch<any>) => (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {...actions, ...ManualOrderActions, ...CategoryActions},
      dispatch
    )
)(Tax);
